import { useQuery } from '@tanstack/react-query';
import { DEFAULT_GC_TIME } from '@/client/constants';
import { useClientStore } from '@/client/stores/client';
import { withErrorHandling } from '@/client/utils/errors';
import { BudgetsData } from '@/client/types/ai-management';
import { aiKeys, unwrapEnvelope } from './overview.query';

export const BUDGETS = '/llm-admin/budgets';

const useBudgetsFn = () => {
  const request = useClientStore((s) => s.request);
  return withErrorHandling(async (): Promise<BudgetsData> => {
    const raw = await request<any>(BUDGETS);
    return unwrapEnvelope<BudgetsData>(raw);
  }, 'Failed to load LLM budgets');
};

export const useBudgetsQuery = (enabled = true) => {
  const queryFn = useBudgetsFn();
  return useQuery({
    queryKey: aiKeys.budgets(),
    queryFn,
    enabled,
    // Spend figures update continuously; keep a short stale window.
    staleTime: 1000 * 30,
    gcTime: DEFAULT_GC_TIME,
  });
};
